// extracted by mini-css-extract-plugin
export var base = "Container-module--base--f02fd";
export var innerContainer = "Container-module--inner-container--d6e6d";
export var main = "Container-module--main--d44ba";
export var standard = "Container-module--standard--d7492";